<template>
    <div id="demo-basic-card">
        <vx-card class="mb-base">
            <div id="allQuestionsLoadingDiv" class="vs-con-loading__container">
                <div class="vx-row mb-base">
                    <div class="vx-col w-1/2">
                        <ul class="demo-alignment">
                            <li>
                                <vs-radio @change="searchQuestions()" v-model="lang" vs-value="all">All</vs-radio>
                            </li>
                            <li>
                                <vs-radio @change="searchQuestions()" v-model="lang" vs-value="da">Danish</vs-radio>
                            </li>
                            <li>
                                <vs-radio @change="searchQuestions()" v-model="lang" vs-value="en">English</vs-radio>
                            </li>
                        </ul>
                    </div>

                    <div class="vx-col w-1/2">
                        <vx-input-group class="mt-2">
                            <vs-input v-model="question_name" />

                            <template slot="append">
                                <div class="append-text btn-addon">
                                    <vs-button @click="searchQuestions()" color="primary" type="filled" icon-pack="feather"
                                        icon="icon-search"></vs-button>
                                </div>
                            </template>
                        </vx-input-group>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <span>Question categories</span>
                        <treeselect v-model="selectedcategories" :multiple="true" :options="question_categories_options"
                            @input="catCanged()" />
                    </div>
                </div>

                <div class="vx-row p-4">
                    <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-if="questionsData.length"
                        v-for="(listItem, index) in questionsData" :key="index">
                        <vx-card>
                            <div slot="no-body" class="imgHolder">
                                <img :src="listItem.picture" alt="content-img" class="responsive card-img-top">
                                <vs-chip class="ag-grid-cell-chip" color="primary">
                                    <span>{{ listItem.lang == 'da' ? "Danish" : "English" }}</span>
                                </vs-chip>
                            </div>
                            <p>{{ listItem.situation }}</p>

                            <div class="flex justify-between flex-wrap">
                                <vs-button @click="editQuestion(listItem)" class="mt-4 mr-2 shadow-lg" type="gradient"
                                    color="primary" icon-pack="feather" icon="icon-edit" icon-after>Edit </vs-button>
                                <vs-button @click="deleteQuestion(listItem)" class="mt-4 mr-2 shadow-lg" type="gradient"
                                    color="danger" icon-pack="feather" icon="icon-trash" icon-after>Delete</vs-button>
                            </div>
                        </vx-card>
                    </div>
                </div>

                <div class="vx-row mt-base">
                    <div class="vx-col w-full">
                        <vs-pagination class="" :total="totalPage" v-model="currentPage"></vs-pagination>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    data() {
        return {
            selectedcategories: [],
            questionsData: [],
            totalPage: 1,
            currentPage: 1,
            question_name: null,
            lang: "all",
            deleteQuestionData: null,
        }
    },
    components: {
        VuePerfectScrollbar,
        Treeselect
    },
    watch: {
        currentPage(val) {
            localStorage.setItem('currentPage', val);

            this.searchQuestions()
        }
    },
    computed: {
        question_categories_options() {
            let categories = this.$store.state.questionManagement.categories
            let categoriesData = []

            categories.forEach(function (entry, key) {
                categoriesData.push({
                    id: entry.id,
                    title: entry.name,
                    label: entry.name,
                })
            });

            return categoriesData
        },
    },
    async mounted() {
        await this.$store.dispatch("questionManagement/viewCategoryWithoutPaginate", { avoid_paginate: "true" })
        this.questionsData = this.$store.state.questionManagement.questions

        this.getAllQuestions()
    },
    methods: {
        async catCanged() {
            this.selected = []

            var self = this
            this.$vs.loading({
                container: '#allQuestionsLoadingDiv',
                scale: 0.6
            })

            let data = {
                lang: this.lang == "all" ? null : this.lang,
                categories: this.selectedcategories,
            }

            await this.$store.dispatch("questionManagement/getAllQuestions", data)
                .then(res => {
                    this.questionsData = res.data.data
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#allQuestionsLoadingDiv > .con-vs-loading')
                })
                .catch(err => {
                    this.$vs.loading.close('#allQuestionsLoadingDiv > .con-vs-loading')
                })


        },
        async searchQuestions() {
            var self = this
            this.$vs.loading({
                container: '#allQuestionsLoadingDiv',
                scale: 0.6
            })

            let data = {
                lang: this.lang == "all" ? null : this.lang,
                question_name: this.question_name,
                // page : this.currentPage,
                categories: this.selectedcategories,
            }

            await this.$store.dispatch("questionManagement/getAllQuestions", data)
                .then(res => {
                    this.questionsData = res.data.data
                    this.totalPage = res.data.last_page
                    this.currentPage = res.data.current_page
                    this.$vs.loading.close('#allQuestionsLoadingDiv > .con-vs-loading')
                })
                .catch(err => {
                    this.questionsData = []
                    this.$vs.loading.close('#allQuestionsLoadingDiv > .con-vs-loading')
                })
        },
        getAllQuestions() {

            this.$vs.loading({
                container: '#allQuestionsLoadingDiv',
                scale: 0.6
            })

            this.$store.dispatch("questionManagement/getAllQuestions")
                .then(res => {
                    console.log(res.data);
                    this.questionsData = res.data.data
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#allQuestionsLoadingDiv > .con-vs-loading')
                    
                    this.currentPage = localStorage.getItem('currentPage');
                    console.log('im ques fetcher : ', this.currentPage);
                })
                .catch(err => {
                    this.$vs.loading.close('#allQuestionsLoadingDiv > .con-vs-loading')
                })
        },
        deleteQuestion(question) {
            this.deleteQuestionData = question;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this Question data ?',
                accept: this.acceptDeleteQuestiom
            })
        },
        acceptDeleteQuestiom() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deleteQuestion", { id: this.deleteQuestionData.id })
                .then(res => {
                    this.getAllQuestions()
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Question deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => {
                    this.$vs.loading.close()
                })
        },
        viewQuestion(question) {
            this.$router.push("/questions/view/" + question.id).catch(() => { })
        },
        editQuestion(question) {
            this.$router.push("/questions/edit/" + question.id).catch(() => { })
        },
    },
    created() {
        if (!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        this.questionsData = this.$store.state.questionManagement.questions

    },

}
</script>
<style lang="css">
.imgHolder {
    position: relative;
}

.imgHolder div {
    position: absolute;
    right: 10px;
    top: 10px;
}</style>

